import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function Mobilemenu() {
  return (

    <nav class="navbar-mobile">
         <ul class="navbar-nav">
            <li class="nav-item">
               <Link className='nav-link' to='/home'>Home</Link>
            </li>

             <li class="nav-item">
               <Link className='nav-link' to='/about'>About Us</Link>
            </li>

          

            {/* <NavDropdown title="About Us" id="basic-nav-dropdown">
              <ul>
                  <li><Link className='order-history-link' to='/about'>About Aadikaash</Link></li>
                  <li><Link className='order-history-link' to='/about-isjs'>About ISJS</Link></li>
                  <li><Link className='order-history-link' to='/about-asjs'>About ASJS</Link></li>
                </ul>
            </NavDropdown> */}

            {/*<NavDropdown title="Exhibitor" id="basic-nav-dropdown">
            <ul>
                 <li> <Link to='/login' className='order-history-link'>Exhibitor Login</Link></li>
                <li> <Link to='/isjs-booking-form' className='order-history-link'>ISJS 2025 Application</Link></li>
                <li> <Link to='/asjs-booking-form' className='order-history-link'>AIJE 2025 Application</Link></li>
                <li> <Link to='/floorplan'>Floor Plan Download</Link></li> 



                 <li> <Link to='/' className='order-history-link'>Exhibitor Login</Link></li>
                 <li> <Link to='/' className='order-history-link'>ISJS 2025 Application</Link></li>
                <li> <Link to='/' className='order-history-link'>AIJE 2025 Application</Link></li> 
                <li> <Link to='/'>Floor Plan Download</Link></li>
                </ul>
            </NavDropdown>*/}

               <li class="nav-item">
               <Link className='nav-link' to='https://crm.aadikaash.com/exhibitor/login'>Exhibitor Login</Link>
            </li>

              <li class="nav-item">
               <Link className='nav-link' to='https://crm.aadikaash.com/visitor'>Visitor</Link>
            </li>

            {/* <NavDropdown title="Visitor" id="basic-nav-dropdown">
            <ul>
                <li><a href="https://perfectdatas.in/aije/visitor" target='_blank'>ISJS 2025 Registration</a></li>
                <li><a href="https://perfectdatas.in/aije/visitor" target='_blank'>ASJS 2025 Registration</a></li>
                </ul>
            </NavDropdown> */}

             <li class="nav-item">
                       <Link className='nav-link' to='/sponsership'>Sponsorship</Link>
                       </li>
           
                       <li class="nav-item">
                       <Link className='nav-link' to='/gallery'>Gallery</Link>
                       </li>

                       <li class="nav-item">
                       <Link className='nav-link' to='/'>Blog</Link>
                       </li>

                       <li class="nav-item">
                       <Link className='nav-link' to='/contact'>Contact</Link>
                       </li>

                          {/* <li class="nav-item"> <Link to='/' className='nav-link'><span class="blink-live new">New</span>Jaipur - ISJS 2025 Exhibitor Form</Link></li>          */}
               {/* <li class="nav-item"> <Link to='/asjs-booking-form' className='nav-link'><span class="blink-live new">New</span>Agra - AIJE 2025 Exhibitor Form</Link></li>  */}
          </ul>

 <ul className='login'>    

                      
              </ul> 
      

     

    </nav>
  )

}

export default Mobilemenu;
